<div class="header">
  <spb-logo title="Privatlån Admin"/>
  <div class="right">
    <spb-toggle-button/>
    @if (service.currentUser()) {
      <span>{{ service.currentUser()?.name }}</span>
      <button [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    }
  </div>
</div>

<mat-menu #menu="matMenu">
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>
